// Promo Data

export default {
  code: {
    label: 'Промокод',
    placeholder: 'Укажите код',
    value: '',
    type: 'text',
    error: null,
    min: 3,
    max: 30,
    req: /[A-Za-zА-Яа-я0-9]/,
    required: false,
    validate: true
  },
  type: {
    label: 'Тип скидки',
    placeholder: 'Выберите значение',
    value: null,
    type: 'select',
    items: [
      { value: 0, name: 'Не указывать' },
      { value: 1, name: 'Процентная' },
      { value: 2, name: 'Фиксированная' },
      { value: 3, name: '3 за 2' }
    ],
    error: null,
    min: null,
    max: null,
    req: null,
    required: true,
    validate: true
  },
  discount: {
    label: 'Скидка',
    value: '',
    type: 'number',
    error: null,
    min: 0,
    max: 9999999,
    req: /[^+\d]/g,
    required: false,
    validate: false
  },
  date: {
    label: 'Дата окончания',
    placeholder: 'Выберите дату',
    value: '',
    type: 'date',
    error: null,
    min: null,
    max: null,
    req: null,
    required: null,
    validate: true
  },
}
